'use client';

import { useEffect } from 'react';

import { Toaster } from '~features/toaster';
import { useTranslations } from '~i18n/hooks';
import { eventsInbox, EventType } from '~shared/services/eventsInbox';
import { abbreviateNumber } from '~utils/numbers';

export const useNotificationEventListener = () => {
	const t = useTranslations('Toaster');
	useEffect(
		() =>
			eventsInbox.onMsg((msg) => {
				switch (msg.type) {
					case EventType.NeuronsOrSubscriptionBought:
						const { amount, meta } = msg.payload;
						const isSubscription = amount === 0 && meta.subscription;
						if (isSubscription) {
							Toaster.showSuccess({
								titleKey: 'subscriptionBoughtTitle',
								text: t('subscriptionBoughtMessage', {
									BENEFIT_TEXT: meta.description,
								}),
							});
						}
						break;

					case EventType.LevelChanged: {
						const { changes, current } = msg.payload;
						if (changes.levelChanged > 0) {
							Toaster.showLevel({
								level: current.level,
							});
						}
						break;
					}

					case EventType.BalanceChanged: {
						const { change, meta } = msg.payload;
						if (change > 0) {
							Toaster.showNeurons({
								amount: abbreviateNumber(change),
							});
							if (meta?.cause === 'credits.mall.exchange') {
								Toaster.showNeuronsBurst({
									amount: abbreviateNumber(change),
								});
							}
						}
						break;
					}
				}
			}),
		[t]
	);
};

export const NotificationEventListener = () => {
	useNotificationEventListener();
	return null;
};
